import axios from "axios";
import { BASE_URL } from "./apis";

const api = axios.create({
   baseURL: BASE_URL,
   headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      redirect: "follow",
   },
});
api.interceptors.request.use(
  (config) => {
    let token = localStorage.getItem('userToken');
    if (token) {
      token = token.replaceAll('"', ''); // Remove any surrounding quotes
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default api;
